import { useState } from "react";
import SnackbarVariant from "./SnackbarVariant";

const useSnackbar = () => {
  const [isOpened, setIsOpened] = useState(false);
  const [message, setMessage] = useState("");
  const [variant, setVariant] = useState<keyof typeof SnackbarVariant>(
    "success"
  );

  const open = (message?: string, variant?: keyof typeof SnackbarVariant) => {
    if (message) {
      setMessage(message);
    }

    if (variant) {
      setVariant(variant);
    }

    setIsOpened(true);
  };

  const close = () => {
    setIsOpened(false);
  };

  return {
    isOpened,
    open,
    close,
    message,
    variant
  };
};

export default useSnackbar;
